import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { persistor, store } from "./store/store.js";
import { PersistGate } from "redux-persist/integration/react";
import { AppRoot } from "./GlobalContainer.jsx";
import { DynamicMenuActionProvider } from "../src/store/ContextApi/DynamicMenuActionContext.tsx";
 



ReactDOM.createRoot(document.getElementById("root")).render(
 
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <AppRoot />
 
      <DynamicMenuActionProvider>
    <App />
  </DynamicMenuActionProvider>,
   

    </PersistGate>
  </Provider>
 
);
